export default __webpack_public_path__ + "static/media/kellehers-thumb.7af7d637.png";